import USER_ROLES from '../../utils/UserRoles';
import { FormCreator } from '../../components';
import { WATCHUSER_ROLE_GROUP } from '../../utils/constants';

export const USERS_REDUCER_KEY = 'users';
export const NEW_USER_UUID = 'new';

export const USER_TYPES = {
  WATCH: "WATCH",
  GATEWAY: "GATEWAY"
}

export const USER_FLOW_STEP_IDS = {
  EMAIL: 'email',
  EXISTING_FOUND: 'existingFound',
  PERSONAL_DETAILS: 'personalDetails',
  COMPANY_DETAILS: 'companyDetails',
  THANKYOU: 'thankyou',
};

export const ADD_USER_FLOW_STEPS = [
  {
    id: USER_FLOW_STEP_IDS.EMAIL,
    title: 'add.user.flow.step.email',
    defaultTitle: 'Enter Contact Details',
    showStage: true,
    showNext: true,
    showPrevious: false,
    showSkip: false,
  },
  {
    id: USER_FLOW_STEP_IDS.EXISTING_FOUND,
    title: 'add.user.flow.step.continue.existing',
    defaultTitle: 'User Already Found',
    showStage: false,
    showNext: false,
    showPrevious: false,
    showSkip: false,
  },
  {
    id: USER_FLOW_STEP_IDS.PERSONAL_DETAILS,
    title: 'add.user.flow.step.personal.details',
    defaultTitle: 'Enter Personal Details',
    showStage: true,
    showNext: true,
    showPrevious: true,
    showSkip: false,
  },
  {
    id: USER_FLOW_STEP_IDS.COMPANY_DETAILS,
    title: 'add.user.flow.step.company.details',
    defaultTitle: 'Fill Company Details',
    showStage: false,
    showNext: true,
    showPrevious: true,
    showSkip: false,
  },
  {
    id: USER_FLOW_STEP_IDS.THANKYOU,
    title: 'add.user.flow.step.user.thankyou',
    defaultTitle: 'Done',
    showStage: true,
    showNext: false,
    showPrevious: false,
    showSkip: false,
  },
];

const { Schema, TYPES } = FormCreator;

export const EMAIL_FORM_ELEMENT_SCHEMA = new Schema(
  TYPES.TEXT,
  'email',
  'Email Address',
  undefined,
  { fullWidth: true },
  [],
  [USER_ROLES.OWNER, USER_ROLES.RELATIVE, USER_ROLES.USER],
);

export const NAME_GROUP_ELEMENT_SCHEMA = {
  ...new Schema(TYPES.GROUP, 'nameGroup'),
  values: [
    new Schema(TYPES.TEXT, 'firstName', 'First Name', undefined, { required: true, fullWidth: true }),
    new Schema(TYPES.TEXT, 'lastName', 'Last Name', undefined, { fullWidth: true }),
  ],
};

export const USER_NAME_ELEMENT_SCHEMA = new Schema(TYPES.TEXT, 'userName', 'User Name', undefined, {
  required: true,
  fullWidth: true,
});
export const PASSWORD_ELEMENT_SCHEMA = new Schema(TYPES.TEXT, 'password', 'Password', undefined, {
  required: true,
  fullWidth: true,
  type: 'password',
});

export const USER_ROLE_ELEMENT_SCHEMA = new Schema(
  TYPES.DROPDOWN,
  'role',
  'User Role',
  undefined,
  { required: true, fullWidth: true },
  [USER_ROLES.USER, USER_ROLES.RELATIVE, USER_ROLES.OWNER],
);

export const USER_MOBILE_ELEMENT_SCHEMA = new Schema(TYPES.TEXT, 'contactNumber', 'Contact Number', undefined, {
  required: true,
  fullWidth: true,
});

export const USER_TYPE_ELEMENT_SCHEMA = {
  ...new Schema(TYPES.DROPDOWN, 'userType', 'User Type', undefined, {required: true, fullWidth: true}, [], [USER_ROLES.USER, USER_ROLES.RELATIVE, USER_ROLES.OWNER]),
  values: Object.keys(USER_TYPES).map(type => ({value: USER_TYPES[type], label: USER_TYPES[type]}))
}

export const COMPANY_ELEMENT_SCHEMA = new Schema(
  TYPES.DROPDOWN,
  'companyId',
  'Company',
  undefined,
  { required: true, fullWidth: true },
  WATCHUSER_ROLE_GROUP,
  [...WATCHUSER_ROLE_GROUP],
);

export const BRANCH_ELEMENT_SCHEMA = new Schema(
  TYPES.DROPDOWN,
  'branchId',
  'Branch',
  undefined,
  { required: true, fullWidth: true },
  WATCHUSER_ROLE_GROUP,
  [...WATCHUSER_ROLE_GROUP],
);

export const HEIGHT_WEIGHT_ELEMENT_SCHEMA = {
  ...new Schema(TYPES.GROUP, 'heightWeightGroup'),
  values: [
    new Schema(TYPES.NUMBER, 'height', 'Height (in cm)', undefined, { fullWidth: true }),
    new Schema(TYPES.NUMBER, 'weight', 'Weight (in Kg)', undefined, { fullWidth: true }),
  ],
};

export const GENDER_SMOKING_ELEMENT_SCHEMA = {
  ...new Schema(TYPES.GROUP, 'genderSmokingGroup'),
  values: [
    {
      ...new Schema(TYPES.DROPDOWN, 'gender', 'Gender', undefined, {fullWidth: true}, [], []),
      values: [{value: "male", label: "Male"}, {value: "female", label: "Female"}, {value: "other", label: "Others"}]
    },
    {
      ...new Schema(TYPES.DROPDOWN, 'smoking', 'Do you Smoke?', undefined, {fullWidth: true}, [], []),
      values: [{value: 1, label: "Yes"}, {value: 0, label: "No"}]
    }
  ]
}

export const DOB_ELEMENT_SCHEMA = new Schema(
  TYPES.DATE,
  'dob',
  'Date of Birth',
  undefined,
  { fullWidth: true, inputType: "date" },
  [],
);

export const CHANGE_PASSWORD_SCHEMA = [
  new Schema(TYPES.TEXT, 'password', 'Password', undefined, { required: true, fullWidth: true }),
]

export const ChangePasswordAdminSchema = {
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      minimum: 4,
    },
  },
}
